<div class="container" *ngIf="rsaProvidedList.length > 0" [ngClass]="{'loaded': isLoaded}">
    <div class="row mb-4">
        <div class="col">
            <div class="card text-center">
                <div class="card-header bg-primary">
                    <h3 class="mb-0">
                        <i class="fa fa-history"></i> RSA Service History 
                        <span class="badge bg-light text-dark">{{rsaProvidedList.length}}</span>
                    </h3>
                </div>
            </div>
        </div>
    </div>
    <div class="timeline-container">
        <div *ngFor="let rsaProvide of rsaProvidedList; let j=index" 
             class="timeline-entry mb-4"
             [ngClass]="{'completed': rsaProvide.serviceStatus === 'Completed', 'in-progress': rsaProvide.serviceStatus === 'In progress'}">
            <div class="card">
                <div class="card-header d-flex flex-wrap justify-content-between align-items-center" 
                     [ngClass]="{'bg-success': rsaProvide.serviceStatus === 'Completed', 'bg-warning': rsaProvide.serviceStatus === 'In progress'}">
                    <div class="d-flex align-items-center flex-wrap">
                        <span class="badge bg-dark me-2">#{{rsaProvide.rsaProvideInstanceNumber}}</span>
                        <span class="d-flex align-items-center">
                            <i class="fa fa-calendar me-1"></i> 
                            <strong>{{rsaProvide.rsaProvidedDate | date:'MMM d, y h:mm a'}} 
                                <span class="badge bg-info ms-1">IST</span>
                            </strong>
                        </span>
                        <span class="badge ms-2 status-badge" 
                              [ngClass]="{'bg-success text-white': rsaProvide.serviceStatus === 'Completed', 'bg-warning text-dark': rsaProvide.serviceStatus === 'In progress'}">
                            <i class="fa" [ngClass]="{'fa-check-circle': rsaProvide.serviceStatus === 'Completed', 'fa-clock-o': rsaProvide.serviceStatus === 'In progress'}"></i>
                            {{rsaProvide.serviceStatus}}
                        </span>
                    </div>
                    <div>
                        <span *ngIf="rsaProvide.rsaProvidedBy || rsaProvide.provider" class="d-flex align-items-center">
                            <span class="me-2"><i class="fa fa-user"></i> Provider:</span>
                            <span class="badge bg-info me-2">{{rsaProvide.provider || rsaProvide.rsaProvidedBy?.providerName}}</span>
                        </span>
                    </div>
                </div>
                <div class="card-body">
                    <div *ngIf="rsaProvide.rsaProvidedBy && rsaProvide.provider !== 'Other'" class="row mb-3">
                        <div class="col-12">
                            <div class="card border-success">
                                <div class="card-header bg-success">
                                    <h5 class="mb-0"><i class="fa fa-phone-square"></i> Provider Contact Information</h5>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <p class="provider-detail">
                                                <strong><i class="fa fa-user"></i> Name:</strong> 
                                                <span class="provider-value">{{rsaProvide.rsaProvidedBy.providerName}}</span>
                                            </p>
                                            <p class="provider-detail">
                                                <strong><i class="fa fa-map-marker"></i> City:</strong> 
                                                <span class="provider-value">{{rsaProvide.rsaProvidedBy.city || 'N/A'}}</span>
                                            </p>
                                        </div>
                                        <div class="col-md-6">
                                            <p class="provider-detail">
                                                <strong><i class="fa fa-phone"></i> Contact:</strong>
                                                <span class="contact-wrapper">
                                                    <span class="badge bg-light text-dark p-2">
                                                        <i class="fa fa-phone-square me-1 text-success"></i>
                                                        {{rsaProvide.rsaProvidedBy.contactNumber || 'N/A'}}
                                                    </span>
                                                    <button *ngIf="rsaProvide.rsaProvidedBy.contactNumber" 
                                                            class="btn btn-sm btn-outline-primary ms-2"
                                                            title="Copy contact number"
                                                            (click)="onCopyContact(rsaProvide.rsaProvidedBy.contactNumber)">
                                                        <i class="fa fa-copy"></i>
                                                    </button>
                                                </span>
                                            </p>
                                            <p class="provider-detail">
                                                <strong><i class="fa fa-home"></i> Address:</strong> 
                                                <span class="provider-value">{{rsaProvide.rsaProvidedBy.providerAddress || 'N/A'}}</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-md-6">
                            <div class="card inner-card mb-3 h-100">
                                <div class="card-header bg-info">
                                    <h5 class="mb-0"><i class="fa fa-user-circle"></i> Customer Details</h5>
                                </div>
                                <div class="card-body">
                                    <p class="detail-item">
                                        <strong><i class="fa fa-user"></i> Caller:</strong> 
                                        <span>{{rsaProvide.callerName || 'N/A'}}</span>
                                    </p>
                                    <p class="detail-item">
                                        <strong><i class="fa fa-phone"></i> Callback:</strong>
                                        <span class="contact-wrapper">
                                            <span class="badge bg-light text-dark p-2">
                                                <i class="fa fa-phone-square me-1 text-info"></i>
                                                {{rsaProvide.callbackNumber || 'N/A'}}
                                            </span>
                                            <button *ngIf="rsaProvide.callbackNumber" 
                                                    class="btn btn-sm btn-outline-primary ms-2"
                                                    title="Copy contact number"
                                                    (click)="onCopyContact(rsaProvide.callbackNumber)">
                                                <i class="fa fa-copy"></i>
                                            </button>
                                        </span>
                                    </p>
                                    <p class="detail-item">
                                        <strong><i class="fa fa-map-marker"></i> State:</strong> 
                                        <span>{{rsaProvide.state || 'N/A'}}</span>
                                    </p>
                                    <p class="detail-item">
                                        <strong><i class="fa fa-building"></i> City:</strong> 
                                        <span>{{rsaProvide.city || 'N/A'}}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        
                        <div class="col-md-6">
                            <div class="card inner-card mb-3 h-100">
                                <div class="card-header bg-secondary">
                                    <h5 class="mb-0"><i class="fa fa-wrench"></i> Service Details</h5>
                                </div>
                                <div class="card-body">
                                    <p class="detail-item">
                                        <strong><i class="fa fa-building"></i> Dealership:</strong> 
                                        <span>{{rsaProvide.dealershipLocation || 'N/A'}}</span>
                                    </p>
                                    <p class="detail-item">
                                        <strong><i class="fa fa-road"></i> Distance:</strong> 
                                        <span class="badge bg-light text-dark">{{rsaProvide.distance || 'N/A'}} km</span>
                                    </p>
                                    <p class="detail-item">
                                        <strong><i class="fa fa-inr"></i> Service Cost:</strong> 
                                        <span class="badge bg-light text-success p-2">₹{{rsaProvide.serviceCost || 'N/A'}}</span>
                                    </p>
                                    <p class="detail-item">
                                        <strong><i class="fa fa-credit-card"></i> Paid By:</strong> 
                                        <span>{{rsaProvide.paidBy || 'N/A'}}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Reimbursement section for "Other" provider -->
                    <div *ngIf="rsaProvide.provider === 'Other' && rsaProvide.reimbursementAmount" class="row mt-3">
                        <div class="col-12">
                            <div class="card border-warning">
                                <div class="card-header bg-warning text-dark">
                                    <h5 class="mb-0"><i class="fa fa-money"></i> Reimbursement Details</h5>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <p class="detail-item">
                                                <strong><i class="fa fa-inr"></i> Amount:</strong> 
                                                <span class="badge bg-light text-success p-2 fw-bold">₹{{rsaProvide.reimbursementAmount}}</span>
                                            </p>
                                        </div>
                                        <div class="col-md-6">
                                            <p class="detail-item">
                                                <strong><i class="fa fa-comment"></i> Comment:</strong> 
                                                <span>{{rsaProvide.reimbursementComment || 'No comment provided'}}</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div *ngIf="rsaProvide.history && rsaProvide.history.length > 0" class="mt-4">
                        <div class="card inner-card">
                            <div class="card-header d-flex justify-content-between align-items-center bg-primary">
                                <div>
                                    <h5 class="mb-0">
                                        <i class="fa fa-history"></i> Request History Timeline
                                    </h5>
                                </div>
                                <div>
                                    <span class="badge bg-light text-dark">
                                        <i class="fa fa-list-ul me-1"></i> {{rsaProvide.history.length}} entries
                                    </span>
                                </div>
                            </div>
                            <div class="card-body p-0">
                                <div class="table-responsive">
                                    <table class="table table-sm table-hover mb-0">
                                        <thead>
                                            <tr>
                                                <th><i class="fa fa-calendar"></i> Date/Time</th>
                                                <th><i class="fa fa-info-circle"></i> Status</th>
                                                <th><i class="fa fa-comment"></i> Comment</th>
                                                <th><i class="fa fa-user"></i> Actioned By</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let history of rsaProvide.history; let i=index" 
                                                [ngClass]="{'table-primary': i === 0}">
                                                <td>
                                                    <span class="badge bg-light text-dark p-2">
                                                        <i class="fa fa-clock-o me-1 text-primary"></i>
                                                        {{history.modifiedTime | date:'MMM d, y h:mm a'}}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span class="badge status-badge" 
                                                        [ngClass]="{'bg-success text-white': history.modifiedStatus === 'Completed', 'bg-warning text-dark': history.modifiedStatus === 'In progress'}">
                                                        <i class="fa" [ngClass]="{'fa-check-circle': history.modifiedStatus === 'Completed', 'fa-clock-o': history.modifiedStatus === 'In progress'}"></i>
                                                        {{history.modifiedStatus}}
                                                    </span>
                                                </td>
                                                <td>{{history.comment || 'No comment provided'}}</td>
                                                <td>
                                                    <span class="badge bg-light text-dark">
                                                        <i class="fa fa-user-circle-o me-1 text-secondary"></i> 
                                                        {{history.actionedBy}}
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Action buttons with improved styling -->
                <div class="card-footer d-flex justify-content-end" *ngIf="!isCertificateExpired && rsaProvide.serviceStatus !== 'Completed'">
                    <button 
                        [disabled]="loading" 
                        class="btn btn-success" 
                        (click)="onMarkAsCompleted(rsaProvide)">
                        <span *ngIf="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        <i class="fa fa-check-circle"></i> Mark as Completed
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
